<template>
  <div class="travel-map-view" data-cy="travel-map-view">
    <iframe
      class="travel-map-view__iframe"
      title="Tracking_Trips Map"
      src="https://app.powerbi.com/reportEmbed?reportId=f22c08e3-1343-43eb-b3ab-425d6519b4bb&autoAuth=true&ctid=eec94eb4-840d-4d2c-a7f1-05b024e60580&pageName=0f89eedccc84b02f438c"
      frameborder="0"
      allowFullScreen="true"
    ></iframe>
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
.travel-map-view {
  padding: 20px;
  &__iframe {
    width: 100%;
    min-height: 800px;
  }
}
</style>
